/* eslint-disable no-mixed-operators */
import React from 'react';
import styles from './Buttons.module.css'
import clsx from "clsx";
import {CircleLoader} from "react-spinners";


export enum EnumColors {
    black = 'black',
    white = 'white',
    gold = 'gold'
}

export enum EnumButtonWeight {
    fat = 'fat',
    slim = 'slim'
}

export enum EnumButtonType {
    outline = 'outline',
    filled = 'filled'
}


interface IProps {
    color: EnumColors,
    onClick: () => void,
    children: string,
    weight?: EnumButtonWeight,
    type?: EnumButtonType
    className?: string,
    disabled?: boolean,
    loading?: boolean
}

export const Buttons = (props: IProps) => {


    if (props.type === EnumButtonType.outline) {
        return (
            <button
                disabled={!!props.disabled}
                className={clsx(
                    styles.button,
                    EnumColors.white === props.color && styles.buttonOutline_white,
                    EnumColors.black === props.color && styles.buttonOutline_black,
                    EnumButtonWeight.slim === props.weight && styles.button_slim,
                    props.className && props.className
                )} onClick={props.onClick}>{props.children}{props.loading && <CircleLoader size={10} color={
               ( EnumColors.gold === props.color && 'black') || (EnumColors.black === props.color && "#B29E7D") || "#B29E7D"
            }/>}</button>
        )
    }

    if (props.type === EnumButtonType.filled) {
        return (
            <button
                disabled={!!props.disabled}
                className={clsx(
                    styles.button,
                    EnumColors.white === props.color && styles.buttonFilled_white,
                    EnumColors.black === props.color && styles.buttonFilled_black,
                    EnumColors.gold === props.color && styles.buttonFilled_gold,
                    !props.color && styles.buttonFilled_white,
                    EnumButtonWeight.slim === props.weight && styles.button_slim,
                    props.className && props.className
                )} onClick={props.onClick}>{props.children} {props.loading && <CircleLoader size={10} color={
                EnumColors.gold === props.color && 'black' ||
                EnumColors.black === props.color && "#B29E7D" || "#B29E7D"
            }/>}</button>
        )
    }

    return (
        <button
            className={clsx(
                styles.button,
                EnumColors.white === props.color && styles.buttonOutline_white,
                EnumColors.black === props.color && styles.buttonOutline_black,
                EnumButtonWeight.slim === props.weight && styles.button_slim,
                props.className && props.className
            )} onClick={props.onClick} disabled={!!props.disabled}>{props.children}{props.loading && <CircleLoader size={10} color={
            EnumColors.gold === props.color && 'black' ||
            EnumColors.black === props.color && "#B29E7D" || "#B29E7D"
        }/>}</button>
    );
};

export default Buttons;